
import React from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import classes from './style.module.css';
import { LOGIN_PAGE_FORM_FIELDS } from '../../../constants/Constants'
import PropTypes from 'prop-types';

const LoginForm = props => {

    let forgotPassword = <button type="button" className={classes.ForgotPasswordLink} onClick={props.forgotPasswordLinkClicked}>Forgot Password?</button>
    if(props.enableForgotPassword === false) forgotPassword = null

    return(
        <Form className={classes.LoginForm} onSubmit={(e) => { e.preventDefault(); props.loginButtonClicked(); }}>
                <h2 className={classes.Title}>{props.title}</h2>
                <Form.Group controlId="loginFormUsernameInput" className={classes.FormGroup}>
                    <Form.Label className={classes.FormLabel}>{LOGIN_PAGE_FORM_FIELDS.USERNAME_TEXT.label}</Form.Label>
                    <Form.Control
                        key={LOGIN_PAGE_FORM_FIELDS.USERNAME_TEXT.key}
                        type="text"
                        placeholder={LOGIN_PAGE_FORM_FIELDS.USERNAME_TEXT.placeHolder}
                        value={props.username === null ? "" : props.username}
                        className={classes.FormControl}
                        onChange={(event) => { props.clearErrorAndSuccessMessages(); props.loginDetailsChanged(LOGIN_PAGE_FORM_FIELDS.USERNAME_TEXT.key, event.target.value);  }} />
                </Form.Group>

                <Form.Group controlId="loginFormPasswordInput" className={classes.FormGroup}>
                    <Form.Label className={classes.FormLabel}>{LOGIN_PAGE_FORM_FIELDS.PASSWORD_TEXT.label}</Form.Label>
                    <Form.Control
                        key={LOGIN_PAGE_FORM_FIELDS.PASSWORD_TEXT.key}
                        type="password"
                        placeholder={LOGIN_PAGE_FORM_FIELDS.PASSWORD_TEXT.placeholder}
                        value={props.password === null ? "" : props.password}
                        className={classes.FormControl}
                        onChange={(event) => { props.clearErrorAndSuccessMessages(); props.loginDetailsChanged(LOGIN_PAGE_FORM_FIELDS.PASSWORD_TEXT.key, event.target.value) }} />
                </Form.Group>
                <div className={classes.CheckboxRow}>
                    <Form.Check
                        key={LOGIN_PAGE_FORM_FIELDS.SAVE_PASSWORD_FLAG_CHECK_BOX.key}
                        type="checkbox"
                        label={LOGIN_PAGE_FORM_FIELDS.SAVE_PASSWORD_FLAG_CHECK_BOX.label}
                        onChange={(event) => { props.clearErrorAndSuccessMessages(); props.loginDetailsChanged(LOGIN_PAGE_FORM_FIELDS.SAVE_PASSWORD_FLAG_CHECK_BOX.key, event.target.value === "on" ? true : false) }} />
                    {forgotPassword}
                </div>
                <Button
                    type="submit"
                    className={classes.SubmitButton}>
                    Sign In
                </Button>
            </Form>
    )
}

LoginForm.propTypes = {
    username: PropTypes.string,
    password: PropTypes.string,
    enableForgotPassword: PropTypes.bool,
    loginDetailsChanged: PropTypes.func.isRequired,
    loginButtonClicked: PropTypes.func.isRequired
}

export default LoginForm